@if (error) {
  <div>
    {{ error }}
  </div>
}
<form [formGroup]="form" (submit)="onSubmit()">
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="text"
        class="input-wide"
        placeholder="Tenant Name"
        formControlName="name"
        />
      @if (nameControl.dirty && nameControl.hasError('required')) {
        <p>
          {{ "tenants.required.name" | translate }}
        </p>
      }
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="text"
        class="input-wide"
        placeholder="Tenant ID"
        formControlName="id"
        [pattern]="urlSlugPattern"
        [readonly]="mode === FormMode.EDIT"
        />
      @if (idControl.dirty && idControl.hasError('pattern')) {
        <p>
          {{ "tenants.invalidSlug" | translate }}
        </p>
      }
      @if (idControl.dirty && idControl.hasError('required')) {
        <p>
          {{ "tenants.required.id" | translate }}
        </p>
      }
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <mat-label>Country</mat-label>
      <mat-select formControlName="country">
        @if ((preferredCountries$ | async).length > 0) {
          <mat-optgroup
            label="{{ 'settings.phone.commonCountryCodes' | translate }}"
            >
            @for (preferred of preferredCountries$ | async; track preferred) {
              <mat-option
                [value]="countryCodeData[preferred].key"
                >
                {{ countryCodeData[preferred].key | countryFlag }}
                {{ countryCodeData[preferred].name }}
              </mat-option>
            }
          </mat-optgroup>
        }
        <mat-optgroup
          label="{{ 'settings.phone.allCountryCodes' | translate }}"
          >
          @for (countryCode of countryCodeList; track countryCode) {
            <mat-option
              [value]="countryCodeData[countryCode].key"
              >
              {{ countryCodeData[countryCode].key | countryFlag }}
              {{ countryCodeData[countryCode].name }}
            </mat-option>
          }
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-slide-toggle formControlName="enabled">{{
      "tenants.enabled" | translate
    }}</mat-slide-toggle>
    @if (form.get('enabled').value === false) {
      <p>
        {{ "tenants.disabled.description" | translate }}
      </p>
    }
  </div>
  <div class="button-group">
    @if (!_readOnly) {
      <button
      [disabled]="
        loading || idControl.errors != null || nameControl.errors != null
      "
        role="button"
        color="primary"
        (click)="onSubmit()"
        ca-raised-button
        >
        {{
        (mode === FormMode.CREATE ? "tenants.create" : "tenants.save")
        | translate
        }}
      </button>
    }
  </div>
</form>
